export default __webpack_public_path__ + "static/blue_sky_desk-06561056cb6c40aab9c96522fa6b287f.webm";